
import { Component, Input, Output, EventEmitter, HostListener, OnChanges } from '@angular/core';

@Component({
  selector: 'app-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.css']
})
export class PopupComponent implements OnChanges {
  @Input() isOpen = false;
  @Input() width: string = '100%';
  @Input() height: string = '85vh';
  @Input() showCloseButton: boolean = true;
  @Input() hasHeaderContent: boolean = false;
  @Input() hasFooterContent: boolean = false;

  @Output() close = new EventEmitter<void>();

  isFullWidth = true;

  ngOnChanges() {
    // Check if width is 100% or uses viewport units
    this.isFullWidth = this.width === '100%' || this.width.includes('vw');

    // Lock body scroll when popup is open
    if (this.isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }

  closePopup(event?: MouseEvent) {
    // Close only when clicking on overlay, not popup content
    this.isOpen = false;
    if (event && event.target === event.currentTarget) {
      this.close.emit();
    }
  }

  stopPropagation(event: MouseEvent) {
    event.stopPropagation();
  }

  @HostListener('document:keydown.escape', ['$event'])
  handleEscapeKey(event: KeyboardEvent) {
    if (this.isOpen) {
      this.isOpen = false;
      this.close.emit();
    }
  }
}